import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// TERM LOAN PAYMENT VERIFICATION
// Legacy: /AccountsApproval/VerifyTermloanPayment (+ VerifyTermloanPaymentGrid / VerifyTermloanPaymentView)
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — term loan repayments pending at this role's level (spGettermloanpaymentgrid).
export const getVerificationTLPayments = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetVerificationtlPDetails`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail by payment transaction no (one-row list: loan, principal / interest split, MOID, TNO).
export const getTLPaymentById = async (rowId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GettlverificationtlpbyId`, { params: { Rowid: rowId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Reject (spVerifyTermloanPayment — success literal "Submitted").
export const verifyTLPayment = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/Verifytermloanpayment`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
